import "primeflex/primeflex.css";
import React, { useEffect, useState, useRef } from "react";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import "primereact/resources/primereact.css";
import { useTranslation } from "react-i18next";
import configureStore from "../../redux/store";
import ApiBaseURLProps from "../other/apiBaseURL";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useToast } from "../other/Toast";
import { authorizationHeader } from "../service/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import LookupService from "../service/lookupService";
import { Image } from "primereact/image";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  NON_DOCUMENT_DETAIL_DOCUMENT,
  filterDocument,
  filterCompanyDocument,
} from "./documentDetails";
import ErrorBlock from "./errorBlock";
import { getTObjectValue, getTValue } from "../other/label";
import { Checkbox } from "primereact/checkbox";
import CustomQRCode from "../lookup/customQRCode"
import ApiService from "../service/apiService"
import CustomImage from "../other/Image";
import apiService from "../service/apiService";
import { confirmDialog } from "primereact/confirmdialog";
import { SaveButton } from "./declerationDetails";
import { KycInfoForPublic } from "../customComponent/KycInfoForPublic";
// import { KycInfoForPublic } from "../customComponent/KycInfoForPublic";


function ViewFormData(props) {
  const history = useHistory();

  // const ldocumentTypeList = useSelector(
  //   (state) => state.lookupDetails.documentTypeList
  // );
  const ldistrictList = useSelector(
    (state) => state.lookupDetails.districtList
  );
  const dispatch = useDispatch();

  useEffect(() => {
    // if (!ldocumentTypeList) {
    //   LookupService.getDocumentTypeList(dispatch);
    // }
    if (!ldistrictList) {
      LookupService.getDistrictList(dispatch);
    }
  }, []);

  const data = useSelector((state) => state);
  const toast = useToast();
  const showError = () => {
    toast.error("Message", "Message Content")
  };
  const { t, i18n } = useTranslation();
  const {
    firstName,
    middleName,
    lastName,
    firstNameNep,
    middleNameNep,
    lastNameNep,
    dob,
    gender,
    pan,
    nationality,
    nationalityDesc,
    nrn,
    nrnId,
    nrnAddress,
    citizenshipNo,
    issuedDistrict,
    issuedDate,
    maritalStatus
  } = data.personalDetails;

  const convertDate = (oDate) => {
    if (!oDate) return "";
    let date = new Date(oDate);
    let yyyy = date.getFullYear();
    let mm = ("0" + (date.getMonth() + 1)).slice(-2);
    let dd = ("0" + date.getDate()).slice(-2);
    let formattedDate = yyyy + "-" + mm + "-" + dd;
    return formattedDate;
  };

  const {
    country,
    countryDesc,
    state,
    stateDesc,
    district,
    districtDesc,
    municipality,
    municipalityDesc,
    ward,
    tole,
    blockNo,
    telephoneNo,
    emailId,
    mobileNo,
    perWard,
    perTole,
    perBlockNo,
    perTelephoneNo,
    perCountry,
    perState,
    perDistrict,
    perMunicipality,
    perCountryDesc,
    perStateDesc,
    perMunicipalityDesc,
    perDistrictDesc,
  } = data.addressDetails;
  const familyDetails = data.familyDetails.relativeList;
  const bankList = data.bankDetails.bankDetailsList;
  const formType = useSelector((state) => state.routerData.formType);
  const isMinor = useSelector((state) => state.personalDetails.isMinor);
  const isNrn = useSelector((state) => state.personalDetails.isNrn);
  const documentForMinor = useSelector(
    (state) => state.personalDetails.documentForMinor
  );
  const locationType = useSelector(
    (state) => state.addressDetails.locationType
  );
  const guardianDetails = data.guardianDetails;
  const occupationDetails = data.occupationDetails;
  const moneyLaunderingDetails = data.moneyLaunderingDetails;
  const boidDetailList = data.boidDetails.boidList;
  const companyList = data.occupationDetails.companyDetailsList;
  const companyRelationDetailsList = data.occupationDetails.companyRelationDetailsList;
  const relativeTypeList = useSelector(
    (state) => state.familyDetails.relativeTypeList
  );
  console.log(relativeTypeList, "tririri");
  const documentDetailList = data.documentDetails.documentList;

  const dynamicDatas = data.dynamicFieldDetails.allDynamicField;
  const dynamicDataList = Object.values(dynamicDatas).filter(v => v.value != null);

  const { fdpId, fdpIdDesc, createBoid, createMeroShareId } = data.boidDetails;

  const photo = documentDetailList.find((d) => d.documentTypeId === "PH") || {};

  const gphoto =
    guardianDetails.guardianDocumentList.find(
      (d) => d.documentTypeId === "PH"
    ) || {};

  const getDescription = (pList, param) => {
    return ((pList && pList.find((p) => p.code === param)) || {}).descEng;
  };

  const permKycId = useSelector((state) => state.routerData.permKycId);
  const tempKycId = useSelector((state) => state.routerData.tempKycId);


  const [qrInfo, setQrInfo] = useState({});
  useEffect(() => {
    if (permKycId) {
      ApiService.getQRInfo(permKycId).then(response => {
        setQrInfo(response.data);
      })
    }
  }, [])

  return (
    <div className="p-col-12 p-md-12">
      <ErrorBlock />

      <div className="p-field p-col-12 p-md-12 p-grid ">

        <div className="p-field p-col-12 p-md-6 p-mb-3">
          <div className="p-col-12 p-md-12">
            <div className="p-col-12 p-md-12"
              style={{
                overflow: "hidden",
                float: "left",
                marginRight: '15px',
              }}
            >
              <CustomImage
                src={
                  photo.fileId
                    ? ApiBaseURLProps.apiBaseURL + "/file/" + photo.fileId
                    : "/photo.png"
                }
                alt="Image Text"
                width={128}
                height={133}
                preview
              />
            </div>
            {permKycId && (
              <CustomQRCode style={{ float: 'left' }} qrInfo={qrInfo} />
            )}


          </div>
        </div>
        <div className="p-field p-col-12 p-md-6 p-mb-3">
          {/* <SaveButton style={{ flex: 1 }} instantAnalysis={true} /> */}
          {/* {(data.personalDetails?.firstName || data.companyDetail?.incorporationDate) &&
            <KycInfoForPublic id={data.routerData?.customerId}
              personDetail={data.personalDetails}
              companyDetail={data.companyDetail}
              bankAccountDetailList={data.bankDetails?.bankDetailsList}
              documentDetails={data.documentDetails?.documentList}
              type={data.routerData?.formType} />
          } */}
        </div>

      </div >
      {tempKycId &&
        <div className="p-col-12 p-md-12">
          <div className="p-field p-col-12 p-md-12">
            <div>
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("kycId")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {permKycId || tempKycId}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>
        </div>
      }
      <div className="p-field p-col-12 p-md-12 p-grid ">
        <div className="p-field p-col-12 p-md-6 p-mb-3">
          <h4 className="p-col-12 p-md-12">
            <p className="section-title p-pt-0">{t("Personal Information")}</p>
          </h4>
          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("nameEnglish")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {firstName} {middleName ? middleName + " " : ""} {lastName}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("nameNepali")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {firstNameNep} {middleNameNep ? middleNameNep + " " : ""}{" "}
                {lastNameNep}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("dateOfBirth")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {"" + convertDate(dob)}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("gender")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {gender == "M"
                  ? "Male"
                  : gender == "F"
                    ? "Female"
                    : gender == "O"
                      ? "Others"
                      : ""}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-field p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("nationality")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {nationalityDesc ? nationalityDesc : nationality}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {" "}
                {t("pan")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">{pan}</span>
            </div>
          </div>
        </div>

        <div className="p-field p-col-12 p-md-6 p-mb-3">
          <h4 className="p-col-12 p-md-12">
            <p className="section-title" style={{ clear: "both" }}>
              {t("boidDetails")}
            </p>
          </h4>
          {boidDetailList.length !== 0 ?
            <div className="p-col-12 p-md-12">
              <DataTable value={boidDetailList} dataKey="doc">
                <Column field="boid" header={t("boid")}></Column>
                <Column
                  body={(rowData) => {
                    return rowData.dpIdDesc ? rowData.dpIdDesc : rowData.dpId;
                  }}
                  header={t("dpName")}
                ></Column>
                <Column body={(rowData) => <Checkbox checked={rowData.isForwarded} />}></Column>
              </DataTable>
            </div> :
            <>            <div className="p-col-12 p-md-12">
              <div className="bdrTop">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("forwardToDp")} :
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {fdpIdDesc || fdpId}
                </span>
                <div style={{ clear: "both" }}></div>
              </div>
            </div>
              <div className="p-col-12 p-md-12">
                <div className="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("createBoid")} :
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {createBoid == true ? "Yes" : "No"}
                  </span>
                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
              <div className="p-col-12 p-md-12">
                <div className="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("createMeroShare")} :
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {createMeroShareId == true ? "Yes" : "No"}
                  </span>
                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
            </>

          }
        </div>

      </div>

      <div className="p-field p-col-12 p-md-12 p-grid">
        <h4 className="p-col-12 p-md-12">
          <p className=" p-col-12 section-title">{t("addressDetails")}</p>
        </h4>
      </div>

      <div className="p-field p-col-12 p-md-12 p-grid ">
        <div className="p-field p-col-12 p-md-6 p-mb-3">
          <h5 className="p-col-12 p-md-12">
            <p className=" subHeading">{t("currentAddress")}</p>
          </h5>
          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("country")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {countryDesc ? countryDesc : country}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("state")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {stateDesc ? stateDesc : state}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("district")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {districtDesc ? districtDesc : district}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("municipality")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {municipalityDesc ? municipalityDesc : municipality}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-field p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("ward")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">{ward}</span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("tole")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">{tole}</span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("blockNo")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {blockNo}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("telephoneNo")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {telephoneNo}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("emailId")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {" "}
                {emailId}{" "}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("mobileNo")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {mobileNo}
              </span>
            </div>
          </div>
        </div>
        <div className="p-field p-col-12 p-md-6 p-mb-3">
          <h5 className="p-col-12 p-md-12">
            <p className="subHeading">{t("permanentAddress")}</p>
          </h5>
          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("country")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perCountryDesc ? perCountryDesc : perCountry}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("state")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perStateDesc ? perStateDesc : perState}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("district")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perDistrictDesc ? perDistrictDesc : perDistrict}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("municipality")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perMunicipalityDesc ? perMunicipalityDesc : perMunicipality}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-field p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("ward")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perWard}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("tole")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perTole}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("blockNo")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perBlockNo}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("telephoneNo")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perTelephoneNo}
              </span>
            </div>
          </div>
        </div>

        <div className="p-field p-col-12 p-md-6 p-mb-3">
          <h4 className="p-col-12 p-md-12">
            <p className="section-title">{t("familyDetails")}</p>
          </h4>

          {familyDetails
            .filter(p => p.relativeType.maritalStatus == null || p.relativeType.maritalStatus === maritalStatus)
            .map((family, index) => {

              return (
                <>
                  <div className="p-field p-col-12 p-md-12 " key={index}>
                    <div className="bdrTop">
                      <label className="p-col-12 p-md-6 form-detail-label">
                        {family.relationTypeDesc
                          ? getTValue(i18n, family.relationTypeDesc, family.relationTypeDescNep)
                          : getTValue(i18n, family.relativeType && family.relativeType.descEng, family.relativeType && family.relativeType.descNep)}

                        :
                      </label>
                      <span className="p-col-12 p-md-6 form-detail-data">
                        {family.firstName}{" "}
                        {family.middleName ? family.middleName + " " : ""}{" "}
                        {family.lastName}
                      </span>
                    </div>
                  </div>
                </>
              );
            })}
        </div>

        <div className="p-field p-col-12 p-md-6 p-mb-3">
          <h4 className="p-col-12 p-md-12">
            <p className="section-title">{t("bankDetails")}</p>
          </h4>
          <div>
            <DataTable
              style={{ minWidth: 600 }} value={bankList} dataKey="bank">
              <Column
                body={(rowData) => {
                  return rowData.typesOfBankAccountDesc
                    ? rowData.typesOfBankAccountDesc
                    : rowData.typesOfBankAccount;
                }}
                header={t("typesOfBankAccount")}
              ></Column>
              <Column
                body={(rowData) =>
                  rowData.bankDesc ? rowData.bankDesc : rowData.bank
                }
                header={t("bank")}
              ></Column>
              <Column
                body={(rowData) => {
                  return rowData.bankBranchDesc
                    ? rowData.bankBranchDesc
                    : rowData.bankBranch;
                }}
                header={t("bankBranch")}
              ></Column>
              <Column
                field="bankAccountNumber"
                header={t("bankAccountNumber")}
              ></Column>
            </DataTable>
          </div>
        </div>

        <h4 className="p-col-12 p-md-12">
          <p className="section-title p-md-12">{t("occupationDetails")}</p>
        </h4>
        <div class="p-field p-col-12 p-md-6 p-mb-3">
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("occupationType")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {occupationDetails.occupationTypeDesc
                  ? occupationDetails.occupationTypeDesc
                  : occupationDetails.occupationType}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("businessType")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {occupationDetails.businessType == "MA"
                  ? "Manufacturing"
                  : occupationDetails.businessType == "SO"
                    ? "Service Oriented"
                    : "Others"}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {" "}
                {t("organizationName")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {occupationDetails.organizationName}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {" "}
                {t("address")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {occupationDetails.address}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {" "}
                {t("designation")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {occupationDetails.designation}
              </span>
            </div>
          </div>
        </div>

        <div class="p-field p-col-12 p-md-6 p-mb-3">
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("employeeId")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {occupationDetails.employeeId
                  ? occupationDetails.employeeId
                  : occupationDetails.docId}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {" "}
                {t("financialDetails")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {occupationDetails.financialDetailsDesc
                  ? occupationDetails.financialDetailsDesc
                  : occupationDetails.financialDetails}
              </span>
            </div>
          </div>

        </div>
        <div className="p-field p-col-12 p-md-12">
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("securitiesTrading")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {occupationDetails.securtitesTrading == "N"
                  ? "NO"
                  : occupationDetails.securtitesTrading == "Y"
                    ? "YES"
                    : ""}
              </span>
            </div>
          </div>
          {occupationDetails.securtitesTrading === "Y" ? (
            <>

              <DataTable value={companyList}>
                <Column
                  field="companyName"
                  header={t("companyName")}
                ></Column>
                <Column
                  field="companyNameOrRelation"
                  header={t("designation")}
                  body={(company) => {
                    return (company.companyDesignationDesc
                      ? company.companyDesignationDesc
                      : company.compDesignationDesc)
                  }}
                ></Column>

              </DataTable>

            </>
          ) : (
            ""
          )}
        </div>
        <div style={{ marginTop: '8rem' }}></div>
        <div className="p-field p-col-12 p-md-12">
          <div className="p-field p-col-12 p-md-12 ">
            <div class="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("securitiesTradingRelation")}
              </label>
            </div>
          </div>
          <DataTable value={companyRelationDetailsList}>
            <Column
              field="companyNameOrRelation"
              header={t("nameAndRelation")}
            ></Column>
            <Column
              field="companyNameRelation"
              header={t("companyName")}
            ></Column>
            <Column
              field="companyNameOrRelation"
              header={t("designation")}
              body={(company) => {
                return (company.designationOthers ? company.designationOthers : (company.companyRelationDesignationDesc
                  ? company.companyRelationDesignationDesc
                  : company.companyRelationDesignation))
              }}
            ></Column>
            <Column
              field="fromAd"
              header={t("fromDate")}
            ></Column>
            <Column
              field="toAd"
              header={t("toDate")}
            ></Column>

          </DataTable>
        </div>

        <h4 className="p-col-12 p-md-12">
          <p className="section-title p-md-12">{t("moneyLaunderingPrevention")}</p>
        </h4>
        <div class="p-field p-col-12 p-md-12 ">
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("politician")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {moneyLaunderingDetails.highRankingOfficial
                  ? "YES"
                  : "NO"}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("relatedPYes")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {moneyLaunderingDetails.relatedHighRankingOfficialName ?
                  (moneyLaunderingDetails.relatedHighRankingOfficialName + "" +
                    (relativeTypeList && (" (" + (relativeTypeList.find(r => r.code === moneyLaunderingDetails.relatedHighRankingOfficialRelation) || {}).descEng + ") "))
                  ) : " (No)"}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {" "}
                {t("bName")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {moneyLaunderingDetails.beneficiaryName ?
                  (moneyLaunderingDetails.beneficiaryName + "" +
                    (relativeTypeList && (" (" + (relativeTypeList.find(r => r.code === moneyLaunderingDetails.beneficiaryRelation) || {}).descEng + ") "))
                  ) : " (No)"}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("felonyName")}:
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {moneyLaunderingDetails.felony ?
                  moneyLaunderingDetails.felony : " (No)"}
              </span>
            </div>
          </div>
        </div>
        {isMinor && (
          <>
            <h4 className="p-col-12 p-md-12">
              <p className="section-title p-md-12">{t("guardianDetails")}</p>
            </h4>
            <div className="p-col-12 p-md-6">
              <div className="p-col-12 p-md-12">
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    overflow: "hidden",
                    float: "right",
                    marginBottom: "15px",
                    marginTop: "25px",
                    border: "1px solid #CCC",
                    textAlign: "center",
                    lineHeight: "100px",
                  }}
                >
                  <CustomImage
                    src={
                      gphoto.fileId
                        ? ApiBaseURLProps.apiBaseURL + "/file/" + gphoto.fileId
                        : "/photo.png"
                    }
                    alt="Image Text"
                    width={100}
                    height={100}
                    preview
                  />
                </div>
              </div>
              <div
                className="p-field p-col-12 p-md-12 "
                style={{ clear: "both" }}
              >
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("nameSurname")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.firstName}
                    {guardianDetails.middleName
                      ? guardianDetails.middleName + " "
                      : ""}
                    {guardianDetails.lastName}
                  </span>
                </div>
              </div>
              <div
                className="p-field p-col-12 p-md-12 "
                style={{ clear: "both" }}
              >
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("nameNepali")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.firstNameNep}
                    {guardianDetails.middleNameNep
                      ? guardianDetails.middleNameNep + " "
                      : ""}
                    {guardianDetails.lastNameNep}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("applicantRelationship")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.relationTypeDesc
                      ? guardianDetails.relationTypeDesc
                      : guardianDetails.relationshipDesc}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("pan")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.pan}
                  </span>
                </div>
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <h5 className="p-col-12 p-md-12">
                <p className="subHeading p-mt-0">
                  {t("correspondenceAddress")}
                </p>
              </h5>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("country")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.countryDesc
                      ? guardianDetails.countryDesc
                      : guardianDetails.country}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("state")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.stateDesc
                      ? guardianDetails.stateDesc
                      : guardianDetails.state}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("district")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.districtDesc
                      ? guardianDetails.districtDesc
                      : guardianDetails.district}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("municipality")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.municipalityDesc
                      ? guardianDetails.municipalityDesc
                      : guardianDetails.municipality}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {" "}
                    {t("ward")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.ward}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {" "}
                    {t("tole")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.tole}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {" "}
                    {t("blockNo")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.blockNo}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("telephoneNo")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.telephoneNo}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("emailId")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.emailId}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {" "}
                    {t("mobileNo")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.mobileNo}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-12 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {" "}
                    {t("fax")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {guardianDetails.fax}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
        <h4 className="p-col-12 p-md-12">
          <p className="section-title p-md-12">{t("documentDetails")}</p>
        </h4>
        <div className="p-field p-col-12 p-md-12 ">
          <DataTable
            style={{ minWidth: 700 }}
            value={documentDetailList.filter(
              (p) =>
                !NON_DOCUMENT_DETAIL_DOCUMENT.includes(p.documentTypeId) &&
                (formType === "I"
                  ? filterDocument(p, {
                    nationality,
                    isMinor,
                    isNrn,
                    documentForMinor,
                    locationType,
                  })
                  : filterCompanyDocument(p, { locationType }))
            )}
            dataKey="document"
          >
            <Column
              field="documentTypeDesc"
              header={t("documentType")}
            ></Column>
            <Column field="docId" header={t("docId")}></Column>
            <Column
              body={(rowData, index) => {
                if (rowData.documentTypeId == "CZ" || rowData.documentTypeId == "BC")
                  return getDescription(ldistrictList, rowData.issuedFrom);
                else return rowData.issuedFromDesc || rowData.issuedFrom;
              }}
              header={t("issuedFrom")}
            ></Column>
            <Column
              body={(rowData, index) => {
                return ((rowData.issuedDate == null || rowData.issuedDate == "") ? ""
                  : new Date(rowData.issuedDate + 'EDT').toISOString().split("T")[0]);
                // rowData.issuedDate &&
                // (typeof rowData.issuedDate === "string"
                //   ? rowData.issuedDate
                //   : rowData.issuedDate.toISOString().split("T")[0])
              }}
              header={t("issuedDate")}
            ></Column>
            <Column field="issuedDateBs" header={t("issuedDateBs")}></Column>
            <Column
              style={{ width: 160 }}
              body={(rowData, index) => {
                return (
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <CustomImage
                      src={
                        rowData.fileId
                          ? ApiBaseURLProps.apiBaseURL +
                          "/file/" +
                          rowData.fileId
                          : "/file_icon.png"
                      }
                      alt="Image Text"
                      width={80}
                      height={80}
                      preview
                    />
                    {rowData.backFileId && (
                      <CustomImage
                        src={
                          rowData.backFileId
                            ? ApiBaseURLProps.apiBaseURL +
                            "/file/" +
                            rowData.backFileId
                            : "/file_icon.png"
                        }
                        alt="Image Text"
                        width={80}
                        height={80}
                        preview
                      />
                    )}
                  </div>
                );
              }}
              header={t("file")}
            ></Column>
          </DataTable>
        </div>
        {dynamicDataList && dynamicDataList.length !== 0 &&
          <div className="p-field p-col-12 p-md-12">
            <h4 className="p-col-12 p-md-12 p-pl-0 p-pr-0">
              <p className="section-title">{t("dynamicDetails")}</p>
            </h4>

            <DataTable value={dynamicDataList} dataKey="bank">
              <Column
                field="label"
              //   header={t("label")}
              ></Column>

              <Column
                body={(rowData) => rowData.value}
              //   header={t("value")}
              ></Column>

            </DataTable>
          </div>
        }
      </div>

    </div >
  );
}

export default ViewFormData;
